import type { ReactNode } from 'react'
import { Check, CornerDownLeft } from 'lucide-react'

/**
 * Contrôles partagés des pages Général / Apparence (LOT 5.5.1) — extraits
 * pour que les deux niveaux (entreprise / personnel) utilisent EXACTEMENT
 * les mêmes composants.
 */

export function Row(props: {
  label: string
  hint?: string | undefined
  children: ReactNode
  inherited?: boolean | undefined
  onInherit?: (() => void) | undefined
}) {
  return (
    <div className="ap-row">
      <span className="ap-row__label">
        {props.label}
        {props.inherited ? <span className="ap-row__inherit-pill">Hérité des réglages de l’entreprise</span> : null}
        {props.hint ? <span className="ap-row__hint">{props.hint}</span> : null}
      </span>
      <span className="ap-row__control">
        {props.children}
        {props.onInherit ? (
          <button className="lc-btn lc-btn--ghost ap-row__inherit" onClick={props.onInherit}
            title="Utiliser la valeur de l’entreprise">
            <CornerDownLeft size={13} /> Valeur de l’entreprise
          </button>
        ) : null}
      </span>
    </div>
  )
}

export function Segmented(props: {
  value: string
  options: { value: string; label: string }[]
  onChange: (v: string) => void
  ariaLabel: string
  disabled?: boolean
}) {
  return (
    <div className="lc-tabs ap-seg" role="group" aria-label={props.ariaLabel}>
      {props.options.map((o) => (
        <button key={o.value}
          className={`lc-tabs__tab${o.value === props.value ? ' lc-tabs__tab--active' : ''}`}
          aria-pressed={o.value === props.value}
          disabled={props.disabled}
          onClick={() => props.onChange(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  )
}

export const SWATCHES = [
  { value: 'violet', color: '#7C5CFF', label: 'Violet LIVE CONTROL' },
  { value: 'blue', color: '#3B82F6', label: 'Bleu' },
  { value: 'cyan', color: '#22D3EE', label: 'Cyan' },
  { value: 'emerald', color: '#10D9A0', label: 'Émeraude' },
  { value: 'amber', color: '#F5A524', label: 'Ambre' },
]

export function AccentPicker(props: {
  value: string
  custom: string
  onChange: (accent: string, custom?: string) => void
  disabled?: boolean
}) {
  return (
    <span className="ap-swatches">
      {SWATCHES.map((s) => (
        <button key={s.value}
          className={`ap-swatch${props.value === s.value ? ' ap-swatch--active' : ''}`}
          style={{ background: s.color }}
          title={s.label} aria-label={s.label} aria-pressed={props.value === s.value}
          disabled={props.disabled}
          onClick={() => props.onChange(s.value)}>
          {props.value === s.value ? <Check size={13} /> : null}
        </button>
      ))}
      <label className={`ap-swatch ap-swatch--custom${props.value === 'custom' ? ' ap-swatch--active' : ''}`}
        title="Couleur personnalisée" style={props.value === 'custom' ? { background: props.custom } : undefined}>
        <input type="color" value={props.custom} disabled={props.disabled}
          onChange={(e) => props.onChange('custom', e.target.value)} aria-label="Couleur personnalisée" />
        {props.value === 'custom' ? <Check size={13} /> : '+'}
      </label>
    </span>
  )
}
